import React, { useEffect, useRef, useState } from 'react';

import { isRoutePreviewActive } from '../helpers/routePreviewState.ts';
import DirectionsResultView from './DirectionsResultView.tsx';
import DirectionsResultViewMobile from './DirectionsResultViewMobile.tsx';
import FullRoutePreview from './FullRoutePreview.tsx';

if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
  import('smoothscroll-polyfill').then(mod => mod.default.polyfill());
}

const DirectionsResult = ({
  bus,
  toggleIsNavigating,
  onNextStepClick,
  onPrevStepClick,
  onStepClickHandler,
  toggleNavigationHeader,
  widgetState,
  isDesktop,
  Loading,
  T,
  onEndRouteClick,
  onEditRouteClick,
  locale,
  isVeryNarrow,
  fullRoutePreviewEnabled = false,
  onStartRoute,
  onEndNavigationClick,
}) => {
  const [state, setWidgetState] = useState(widgetState.getState());
  const previousIsNavigating = useRef(state.isNavigating);

  useEffect(() => widgetState.addCallback(setWidgetState), [widgetState]);
  useEffect(() => {
    previousIsNavigating.current = state.isNavigating;
  }, [state.isNavigating]);

  // Published so the route overview can measure how much of the map the bottom bar covers
  const bottomBarRef = useRef(null);
  useEffect(() => {
    widgetState.update({ overviewBottomBarRef: bottomBarRef });
  }, [widgetState]);

  const preferredUnits = state.preferredUnits;

  if (fullRoutePreviewEnabled && state.isRoutePending) {
    return <Loading />;
  }

  const showPreview = isRoutePreviewActive(state, fullRoutePreviewEnabled);

  const view = showPreview ? (
    <FullRoutePreview
      state={state}
      bus={bus}
      T={T}
      locale={locale}
      isDesktop={isDesktop()}
      onStart={onStartRoute}
      containerRef={bottomBarRef}
      focusOnMount={previousIsNavigating.current}
    />
  ) : isDesktop() ? (
    <DirectionsResultView
      {...state}
      isNavigating={true}
      onPrevStepClick={onPrevStepClick}
      onNextStepClick={onNextStepClick}
      onEndNavigationClick={fullRoutePreviewEnabled === true && state.isNavigating ? onEndNavigationClick : undefined}
      onStepClicked={onStepClickHandler}
      currentRouteType={state.currentRouteType}
      preferredUnits={preferredUnits}
      T={T}
      isDesktop={isDesktop()}
      locale={locale}
    />
  ) : (
    <DirectionsResultViewMobile
      {...state}
      fullRoutePreviewEnabled={fullRoutePreviewEnabled === true}
      containerRef={bottomBarRef}
      bus={bus}
      onPrevStepClick={onPrevStepClick}
      onNextStepClick={onNextStepClick}
      onEndNavigationClick={fullRoutePreviewEnabled === true && state.isNavigating ? onEndNavigationClick : undefined}
      onStepClicked={onStepClickHandler}
      toggleIsNavigating={toggleIsNavigating}
      toggleNavigationHeader={toggleNavigationHeader}
      onEditRouteClick={onEditRouteClick}
      onEndRouteClick={onEndRouteClick}
      preferredUnits={preferredUnits}
      T={T}
      locale={locale}
      isVeryNarrow={isVeryNarrow}
    />
  );

  return state.hasLoaded ? view : <Loading>{view}</Loading>;
};

export default DirectionsResult;
